<template>
  <div class="inventoryItems">
    <div class="head-box">
      <h4>{{ typeName }}单</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入要查询的单号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10" v-if="type">
          新增{{ typeName }}
        </el-button>
        <el-button
          v-if="osg.has(path + ',export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'is:state|integer#and': state == 'all' ? null : 1,
                'regex:name|string#and': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'inventoryItem',
                title: typeName + '单'
              },
              { dynamic: true, preset }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <!-- 动态列 -->
          <c-table :fields="extFields">
            <template slot="handleType">
              <el-table-column
                :label="type ? typeName + '类型' : '出入库类型'"
                :formatter="formatHandleType"
              ></el-table-column>
            </template>
            <template slot="handleDate">
              <el-table-column
                :label="type ? typeName + '时间' : '出入库时间'"
                prop="handleDate"
              ></el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="90" label="操作">
            <template slot-scope="scope">
              <!-- <el-button @click.native.prevent="doEdit(scope.row)" size="mini">
                编辑
              </el-button> -->
              <template v-if="osg.has('InventoryItems?type=1,invalid')">
                <template v-if="scope.row.state == 0">
                  <el-button type="danger" size="mini" disabled>
                    已作废
                  </el-button>
                </template>
                <template v-else>
                  <el-button
                    @click.native.prevent="doDisable(scope.row._id)"
                    type="danger"
                    size="mini"
                  >
                    作废
                  </el-button>
                </template>
              </template>
              <!-- <template>
                <el-button @click.native.prevent="doRemove(scope.row._id)" size="mini">
                  删除
                </el-button>
              </template> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="typeName"
      :visible.sync="openDetail"
      destroy-on-close
      @closed="doInit"
      width="1000px"
      custom-class="c-dialog-height"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        :area="area"
        labelWidth="100px"
        @changeForm="osg.changeForm"
      >
        <template slot="warehouseId">
          <el-select
            v-model="formData.warehouseId"
            placeholder="可以通过输入仓库名称查询"
            clearable
            filterable
          >
            <el-option
              v-for="item in options.warehouses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span class="c-fl">{{ item.label }}</span>
              <span class="c-fr c-font-13">{{ item.code }}</span>
            </el-option>
          </el-select>
        </template>
      </c-form>
      <!-- 入库-产品 -->
      <el-popover
        placement="right"
        width="600"
        trigger="manual"
        v-model="product.show"
        v-if="formData.type == 1 && openDetail"
      >
        <div>
          <el-input
            class="search-input"
            style="width:300px"
            placeholder="请输入产品名称/编号/型号搜索"
            v-model="product.searchValue"
            clearable
            @clear="
              product.fpi.page = 1;
              getProducts();
            "
            @keyup.enter.native="
              product.fpi.page = 1;
              getProducts();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                product.fpi.page = 1;
                getProducts();
              "
            ></el-button>
          </el-input>
        </div>
        <el-table
          height="400px"
          ref="product"
          :data="product.fpi.data"
          empty-text="没有查询到产品"
          @selection-change="selectProducts"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            property="name"
            label="产品名称"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="code"
            width="100px"
            show-overflow-tooltip
            label="产品编号"
          ></el-table-column>
          <el-table-column
            property="exts.model"
            width="100px"
            show-overflow-tooltip
            label="规格型号"
          ></el-table-column>
          <el-table-column
            property="productType"
            label="类型"
            :formatter="formatProductType"
          ></el-table-column>
          <el-table-column
            property="unit"
            label="单位"
            :formatter="formatProductUnit"
          ></el-table-column>
          <el-table-column property="cost" label="成本/元"></el-table-column>
          <el-table-column property="price" label="单价/元"></el-table-column>
          <el-table-column property="createTime" width="140px" label="创建时间"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            class="pagination c-m-t-10 c-m-b-10"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="product.fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="product.fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="product.fpi.total"
          ></el-pagination>
          <div class="c-fr">
            <el-button type="primary" @click="addProducts">
              确认
            </el-button>
            <el-button @click="cancelProducts">
              取消
            </el-button>
          </div>
        </div>
        <el-button slot="reference" type="primary" class="c-fr" @click="openProducts">
          添加产品
        </el-button>
      </el-popover>
      <!-- 出库-库存 -->
      <el-popover
        placement="right"
        width="600"
        trigger="manual"
        v-model="inventory.show"
        v-if="formData.type == 2 && openDetail"
      >
        <div>
          <el-input
            class="search-input"
            style="width:300px"
            placeholder="请输入库存名称/编号搜索"
            v-model="inventory.searchValue"
            clearable
            @clear="
              inventory.fpi.page = 1;
              getInventory();
            "
            @keyup.enter.native="
              inventory.fpi.page = 1;
              getInventory();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                inventory.fpi.page = 1;
                getInventory();
              "
            ></el-button>
          </el-input>
        </div>
        <el-table
          height="400px"
          ref="inventory"
          :data="inventory.fpi.data"
          empty-text="没有查询到产品"
          @selection-change="selectInventory"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            property="name"
            label="名称"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="code"
            width="120px"
            show-overflow-tooltip
            label="编号"
          ></el-table-column>
          <el-table-column
            property="exts.model"
            width="120px"
            show-overflow-tooltip
            label="型号"
          ></el-table-column>
          <el-table-column
            property="unit"
            label="单位"
            :formatter="formatProductUnit"
          ></el-table-column>
          <el-table-column
            property="productType"
            label="类型"
            :formatter="formatProductType"
          ></el-table-column>
          <el-table-column property="count" label="库存数量"></el-table-column>
          <el-table-column property="warehouseName" label="所属仓库"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            class="pagination c-m-t-10 c-m-b-10"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="inventory.fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="inventory.fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="inventory.fpi.total"
          ></el-pagination>
          <div class="c-fr">
            <el-button type="primary" @click="addInventory">
              确认
            </el-button>
            <el-button @click="cancelInventory">
              取消
            </el-button>
          </div>
        </div>
        <el-button slot="reference" type="primary" class="c-fr" @click="openInventory">
          添加产品
        </el-button>
      </el-popover>
      <el-table ref="productList" :data="formData.productList">
        <el-table-column label="产品名称" width="120px" prop="name"></el-table-column>
        <el-table-column label="产品编号" width="100px" prop="code"></el-table-column>
        <el-table-column label="规格型号" width="100px" prop="model"></el-table-column>
        <el-table-column
          label="单位"
          width="50px"
          prop="unit"
          :formatter="formatProductUnit"
        ></el-table-column>
        <el-table-column label="入库数量" width="150px" v-if="formData.type == 1">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.count"
              :controls="false"
              :precision="0"
              :min="1"
              :disabled="scope.row.pIICodes.length > 0 ? true : false"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          label="库存数量"
          width="80px"
          prop="inventoryCount"
          v-if="formData.type == 2"
        ></el-table-column>
        <el-table-column label="出库数量" width="150px" v-if="formData.type == 2">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.count"
              :controls="false"
              :precision="0"
              :min="1"
              :max="scope.row.inventoryCount"
              :disabled="scope.row.pIICodes.length > 0 ? true : false"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="序列号" width="250px">
          <template slot-scope="scope">
            <el-select
              style="width:100%"
              :class="formData.type == 1 && !scope.row.verify ? 'sel-danger' : ''"
              v-model="scope.row.pIICodes"
              @change="codesChange(scope.row)"
              multiple
              filterable
              clearable
              :allow-create="formData.type == 1 ? true : false"
              default-first-option
              :multiple-limit="scope.row.inventoryCount || 0"
              :placeholder="
                formData.type == 1 ? '请输入序列号后选择，可多选' : '请选择要出库设备的序列号'
              "
              :no-data-text="formData.type == 1 ? '请输入序列号后选择，可多选' : ''"
              :no-match-text="formData.type == 1 ? '请输入序列号后选择，可多选' : ''"
            >
              <el-option
                v-for="pIICode in scope.row.pIIOptions || []"
                :key="pIICode"
                :label="pIICode"
                :value="pIICode"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.memo"></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="80" label="操作">
          <template slot-scope="scope">
            <el-button @click.native.prevent="productDelete(scope.$index)" size="mini">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'inventoryItems',
  data() {
    window.$this = this;
    return {
      type: '', //出入库明细类型
      typeName: '',
      name: 'inventoryItem',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        productList: [],
        exts: {}
      },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_type: {
          codeId: 'inventoryItemType'
        },
        codecfg_productUnit: {
          codeId: 'partUnit'
        },
        codecfg_productType: {
          codeId: 'productType'
        },
        pIICodes: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      product: {
        show: false,
        searchValue: '',
        fpi: { data: [] },
        selectedRows: []
      },
      inventory: {
        show: false,
        searchValue: '',
        fpi: { data: [] },
        selectedRows: []
      },
      path: ''
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('inventoryItem', () => {
      this.typeName = this.osg.codelabel('type', this.type) || '出入库明细';
      this.osg.getFpi();
      this.getData();
      this.getWarehouses();
    });
  },
  methods: {
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    formatHandleType(row) {
      return this.osg.codelabel('handleType' + row.type, String(row.handleType));
    },
    formatProductUnit(row, column, cellValue) {
      return this.osg.codelabel('productUnit', cellValue);
    },
    pageSizeChange(pageSize) {
      if (this.product.show) {
        this.product.fpi.rows = pageSize;
        this.getProducts();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.product.show) {
        this.product.fpi.page = currentPage;
        this.getProducts();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.path = decodeURIComponent(
        (window.location.pathname + window.location.search).substring(1)
      );
      this.type = this.osg.param('type');
      this.openDetail = false;
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
      this.upload.data = {};
      this.formData = { type: this.type, productList: [], exts: {} };
      this.$util.renderExtField(this.extFields, this.formData);
      this.product.show = false;
      this.$forceUpdate();
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        'is:type|integer#and': this.type,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/inventoryItem/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        // 赋值
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      row.productList = row.productList || [];
      this.formData = row;
      this.openDetail = true;
      this.formatProduct();
    },
    // 动态查询渲染产品的名称和单位
    formatProduct() {
      let productList = this.formData.productList;
      let arr = [];
      productList.map(item => {
        arr.push(item.id);
      });

      this.osg.ajax(
        'basic/product/query.do',
        {
          _all: '1',
          'in:_id|array#and': arr.join(),
          'in:productType|array#and': '2,3'
        },
        res => {
          for (let item of productList) {
            for (let obj of res.data) {
              if (item.id == obj._id) {
                item.name = obj.name;
                item.unit = obj.unit;
                break;
              }
            }
          }
        },
        {
          noload: true
        }
      );
    },
    doSave() {
      let row = this.$util.deepCopy(this.formData);
      let params = row;
      params.area = params.area || [];
      if (params.area.length > 0) {
        params.province = params.area[0] || '';
        if (params.area.length > 1) {
          params.city = params.area[1] || '';
          if (params.area.length > 2) {
            params.district = params.area[2] || '';
            if (params.area.length > 3) {
              params.subdistrict = params.area[3] || '';
            }
          }
        }
      }
      this.$util.saveExtField(this.extFields, row);
      if (this.osg.validate()) {
        if (row.productList.length == 0) {
          this.osg.alert('请添加产品', 'warning');
          return;
        }
        for (let item of row.productList) {
          if (!item.count) {
            this.osg.toast('请填写' + this.typeName + '数量', 'warning');
            return;
          }
          if (row.type == 1 && !item.verify) {
            this.osg.toast('序列号重复，请勿重复入库！', 'warning');
            return;
          }
        }
        if (this.type == 2) {
          for (let item of row.productList) {
            delete item.inventoryCount;
          }
        }
        this.osg.ajax('basic/inventoryItem/upsert.do', { json: JSON.stringify(row) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/inventoryItem/changeState.do', { id, state: 1 }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.confirm('是否确认作废？作废后将无法恢复！', () => {
        this.osg.ajax('basic/inventoryItem/changeState.do', { id, state: 0 }, () => {
          this.getData();
          this.osg.toast('已作废！');
        });
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/inventoryItem/changeState.do', { id, state: -1 }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getWarehouses() {
      this.osg.ajax('basic/wareHouse/query.do', { _all: '1', 'is:state|integer#and': 1 }, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.warehouses = res.data;
      });
    },
    //点击添加产品按钮
    openProducts() {
      this.product = {
        show: true,
        searchValue: '',
        fpi: { data: [] },
        selectedRows: []
      };
      this.getProducts();
    },
    // 查询未添加的产品
    getProducts() {
      // 收集已添加产品的_id
      let productList = this.formData.productList;
      let arr = [];
      for (let product of productList) {
        arr.push(product.id);
      }

      let params = {
        page: this.product.fpi.page,
        rows: this.product.fpi.rows,
        'is:state|integer#and': 1,
        'is:productState|integer#and': 3, //审核通过
        'regex:name|string#or': this.product.searchValue,
        'regex:code|string#or': this.product.searchValue,
        'regex:exts.model|string#or': this.product.searchValue,
        'nin:_id|array#and': arr,
        'in:productType|array#and': '2,3', //实物产品,备件
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('basic/product/query.do', params, res => {
        this.product.fpi = res;
        this.$nextTick(() => {
          this.$refs.product.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择产品
    selectProducts(rows) {
      if (rows) {
        this.product.selectedRows = rows;
      } else {
        this.$refs.product.clearSelection();
        this.product.selectedRows = [];
      }
    },
    // 确认添加选中的产品
    addProducts() {
      let productList = [];
      this.product.selectedRows.map(item => {
        productList.push({
          id: item._id,
          name: item.name,
          code: item.code,
          model: item.exts && item.exts.model,
          unit: item.unit,
          count: 0,
          handleCount: 0,
          memo: '',
          pIICodes: [],
          verify: true //是否允许入库的校验
        });
      });
      this.formData.productList = this.formData.productList.concat(productList);
      this.cancelProducts();
    },
    // 关闭添加产品弹窗 并取消已选中产品
    cancelProducts() {
      this.product.show = false;
      this.selectProducts();
    },
    // 移除已添加的单个产品
    productDelete(i) {
      this.formData.productList.splice(i, 1);
    },
    //点击添加产品按钮
    openInventory() {
      if (!this.formData.warehouseId) {
        this.osg.toast('请先选择出库仓库', 'warning');
        return;
      }
      this.inventory = {
        show: true,
        searchValue: '',
        fpi: { data: [] },
        selectedRows: []
      };
      this.getInventory();
    },
    getInventory() {
      // 收集已添加产品的_id
      let productList = this.formData.productList;
      let arr = [];
      for (let product of productList) {
        arr.push(product.id);
      }

      let params = {
        page: this.inventory.fpi.page,
        rows: this.inventory.fpi.rows,
        'is:state|integer#and': 1,
        'regex:name|string#or': this.inventory.searchValue,
        'regex:code|string#or': this.inventory.searchValue,
        'is:warehouseId|string#and': this.formData.warehouseId,
        'nin:bizId|array#and': arr,
        'gt:count|integer#and': 0,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax('basic/inventory/query.do', params, res => {
        this.inventory.fpi = res;
        this.$nextTick(() => {
          this.$refs.inventory.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 选择产品库存
    selectInventory(rows) {
      if (rows) {
        this.inventory.selectedRows = rows;
      } else {
        this.$refs.inventory.clearSelection();
        this.inventory.selectedRows = [];
      }
    },
    // 确认添加选中的产品库存
    addInventory() {
      let productList = [];
      this.inventory.selectedRows.map(item => {
        productList.push({
          id: item.bizId,
          name: item.name,
          unit: item.unit,
          inventoryCount: item.count,
          count: 0,
          handleCount: 0,
          memo: '',
          pIIOptions: item.productInventoryItemCodes || [],
          pIICodes: []
        });
      });
      this.formData.productList = this.formData.productList.concat(productList);
      this.cancelInventory();
    },
    // 关闭添加产品库存弹窗 并取消已选中产品库存
    cancelInventory() {
      this.inventory.show = false;
      this.selectInventory();
    },
    codesChange(row) {
      row.count = row.pIICodes.length;
      if (this.formData.type == 1) {
        if (row.pIICodes.length > 0) {
          // 校验是否已入库
          this.osg.ajax(
            '/basic/productInventoryItem/checkInventoryExistsByCode.do',
            {
              codes: row.pIICodes.join(),
              productId: row.id
            },
            res => {
              if (res.data && res.data.length > 0) {
                this.osg.alert('序列号' + String(res.data) + '已入库，请勿重复入库！', 'warning');
                row.verify = false;
              } else {
                row.verify = true;
              }
            },
            { noload: true }
          );
        } else {
          row.verify = true;
        }
      }
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      // this.doInit();
      // this.osg.getFpi();
      // this.getData();
      // this.Refresh();
    },
    type(val) {
      if (this.options.type) {
        this.typeName = this.osg.codelabel('type', val) || '出入库明细';
      }
    }
  }
};
</script>
<style>
.inventoryItems .c-dialog-height {
  height: 80vh !important;
}
.sel-danger .el-input__inner {
  border: 1px solid #f56c6c !important;
}
</style>
